export default __webpack_public_path__ + "static/media/30cfa183902b9b909d430a10bf1f1812.svg";